import { ProgressBar } from "./ProgressBar";
import { Percent } from "./styles";

interface Props {
    warehouseKey: string;
    warehouse: any;
}

export const WarehouseRow = ({ warehouseKey, warehouse }: Props) => {

    const percent = ((warehouse.occupied / warehouse.totalSpaces) * 100).toFixed(1);
    const percentFree = ((warehouse.free / warehouse.totalSpaces) * 100).toFixed(1);

    return (
        <tr>
            <td>{warehouseKey}</td>
            <td>{warehouse.occupied} / {warehouse.totalSpaces} <Percent>({percent}%)</Percent><br/><ProgressBar occupied={warehouse.occupied} total={warehouse.totalSpaces}></ProgressBar></td>
            <td>{warehouse.free} <Percent>({percentFree}%)</Percent></td>
        </tr>
    );
}